<template>
  <div v-show="loading || loadingFinished">
    <transition name="loading-finished" :duration="600">
      <svg
        v-show="loadingFinished"
        class="loading-finished"
        xmlns="http://www.w3.org/2000/svg" version="1.1" :width="size" :height="size" viewBox="0 0 440 440"
      >
        <g :stroke="color" fill="none" stroke-linecap="round">
          <circle
            class="finished-circle"
            cx="220"
            cy="220"
            r="200"
            :stroke-width="circleWidth"
            transform="rotate(-90, 220 220)"
            stroke-dasharray="1256.5"
            stroke-dashoffset="0"
          />
          <path
            d="M120 230 L190 300 L320 160"
            :stroke-width="circleWidth"
            stroke-linejoin="round"
            stroke-dasharray="291.1 0"
            stroke-dashoffset="1"
          />
        </g>
      </svg>
    </transition>
    <svg
      v-show="loading && !loadingFinished"
      xmlns="http://www.w3.org/2000/svg" version="1.1" :width="size" :height="size" viewBox="0 0 440 440"
    >
      <g :stroke="color" fill="none" stroke-linecap="round">
        <circle
          cx="220"
          cy="220"
          r="200"
          :stroke-width="circleWidth"
          transform="rotate(-90, 220 220)"
        >
          <animate
            attributeName="stroke-dasharray"
            begin="0"
            dur="1.2"
            repeatCount="indefinite"
            calcMode="spline"
            values="2 1254.5; 942.375 314.125; 2 1254.5"
            keyTimes="0; .2; 1"
            keySplines="0 0 1 1; 0 .5 .5 1"
          />
          <animate
            attributeName="stroke-dashoffset"
            begin="0"
            dur="1.2"
            repeatCount="indefinite"
            calcMode="spline"
            values="1; 1; -1255.5"
            keyTimes="0; .2; 1"
            keySplines="0 0 1 1; 0 .5 .5 1"
          />
        </circle>
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    loadingFinished: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#fff',
    },
    size: {
      type: String,
      default: '24',
    },
    circleWidth: {
      type: String,
      default: '40',
    },
  },
}
</script>
<style lang="less" scoped>
svg {
  display: block;
}
.loading-finished-enter-active {
  circle {
    transition: stroke-dashoffset .4s linear;
    stroke-dashoffset: 0;
  }
  path {
    transition: stroke-dasharray .3s .3s linear;
    stroke-dasharray: 291.1 0;
  }
}

.loading-finished-enter {
  circle {
    stroke-dashoffset: 1256.5;
  }
  path {
    stroke-dasharray: 0 291.1;
  }
}
.loading-finished-leave-active {
  display: none;
}
</style>




// WEBPACK FOOTER //
// icon.vue?c10c3462